import { MouseEvent } from 'react'
import moment from 'moment'
import { GetPreProcessHS, SemDownloadHS } from 'src/commons/store/BasisStore'
import { sha256 } from 'js-sha256'
import md5 from 'js-md5'

export const ACTIVE_12_NO = 'AT5550500854873092726'
export const ACTIVE_NEWYEAR_NO = 'AT5557838191672197583'

//export const PhonePattern = /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\s?\d{4}\s?\d{4}\s?$/
export const CardIdPattern = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/

/* eslint-disable-next-line */
export const NamePattern = /^(([a-zA-Z+\.?\·?a-zA-Z+]{2,30}$)|([\u4e00-\u9fa5+\·?\u4e00-\u9fa5+]{2,30}$))/
export const PhonePattern = /^1\d{2}\s?\d{4}\s?\d{4}\s?$/
export const QQPattern = /^[1-9]\d{4,11}$/
export const PhoneOrQQPattern = /(^1\d{2}\s?\d{4}\s?\d{4}\s?)|(^[1-9]\d{4,11}$)/

/** sem特殊要求， 匹配到当前渠道不显示微信登录入口 */
// export const notViewWechatEntry = ['360gh09sh', '360th10', '360th09', '360ghsh10', '360lqgh', 'sggh09sh']

export function GUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export enum GameOrderType { //['', '购买游戏账号', '直充游戏', '购买可回收游戏', '游戏试玩']
  '购买游戏账号' = 1,
  '直充游戏' = 2,
  '购买试玩账号' = 3,
  '游戏试玩' = 4,
}

export enum GameOrderStatus { //['未支付', '支付成功', '购买成功', '处理中', '购买失败', '维权中', '退款成功', '退款失败']
  '未支付' = 0,
  '支付成功' = 1,
  '购买成功' = 2,
  '处理中' = 3,
  '购买失败' = 4,
  '维权中' = 5,
  '退款成功' = 6,
  '退款失败' = 7,
  '取消维权' = 8,
  '已结束' = 9,
  '退款中' = 10,
}

export const OpenLink = (Link?: string, IsStop?: boolean, ClickEvent?: () => void) => {
  if (Link) {
    if (window.FuluApp) {
      return {
        onClick: (e?: MouseEvent) => {
          if (IsStop) {
            e?.stopPropagation()
          }
          window.FuluApp!.JSNotifyCppFunc('open_url', Link)
          ClickEvent?.()
        },
      }
    }
    return {
      href: Link,
      target: '_blank',
      onClick: (e?: MouseEvent) => {
        if (IsStop) {
          e?.stopPropagation()
        }
        ClickEvent?.()
      },
    }
  }
  return {}
}

export const FormatUserId = (UserId: number) => {
  return `U${UserId.toString(16)}`
}

/**
 * 折扣语义化
 * @param {Number} Discount 折扣
 */
export const discountSemantics = (Discount: number): string => {
  /*if (Discount * 100 < 10) {
    return '特惠'
  } else*/
  if (isNaN(Discount)) {
    return '10折'
  }

  if (Discount >= 1) {
    return '10折'
  }
  const Str = `${Math.floor(Discount * 100) / 10}`
  return `${Str.replace('.0', '')}折`
}

/**
 * 随机生成手机号
 */
export const CratePhoneNum = () => {
  let PhoneHeader = `${Random(100, 999)}`
  while (!/^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))$/.test(PhoneHeader)) {
    PhoneHeader = `${Random(100, 999)}`
  }
  return `${PhoneHeader}****${Random(1000, 9999)}`
}

/** 隐藏手机号中间四位 */
export const formatHideMobile = (mobile: string) => {
  return `${mobile.substr(0, 3)}****${mobile.substr(7, 11)}`
}

/**
 * 获取渠道
 */
export const GetChannel = () => {
  const recordUrl = localStorage.getItem('firstUrl')
  const finalLocation = recordUrl ? new URL(recordUrl) : window.location
  /*通过域名获取渠道*/
  const HostChannel = finalLocation.host.substr(0, finalLocation.host.indexOf('.'))
  /*通过 URL 查询字段获取渠道*/
  const Query = new URLSearchParams(finalLocation.search.substr(1, finalLocation.search.length))
  return Query.get('channel') || HostChannel
}

/*平台下载地址*/
export const PlatformDownloadUrl = {
  1: 'https://media.st.dl.bscstorage.net/client/installer/SteamSetup.exe',
  2: 'https://www.dm.origin.com/download',
  4: 'https://www.ubisoft.com.cn/clicks/12',
  5: 'https://launcher-public-service-prod06.ol.epicgames.com/launcher/api/installer/download/EpicGamesLauncherInstaller.msi',
  6: 'https://www.blizzard.com/zh-tw/download/confirmation?platform=windows&locale=zhTW&version=LIVE&id=bnetdesk',
}

export const CreateOnlineUser = () => {
  const currentDate = moment().hour()
  let base = 0
  if (currentDate >= 2 && currentDate <= 11) {
    base = 260772
  }
  if (currentDate >= 12 && currentDate <= 17) {
    base = 380696
  }
  if ((currentDate >= 18 && currentDate <= 24) || currentDate <= 2) {
    base = 571541
  }
  return Math.floor(
    base * (0.95 + Math.floor((Math.random() * ((1.27 - 0.95) * 100)) / 100)) - Math.floor(Math.random() * 2200),
  )
}

/*下载地址*/
export const downUrl = () => {
  return `http://download.99box.com/?f=${GetChannel() || 'steam9'}`
}

/*创建下载客户端 iframe*/
export const CreateDownloadIframe = (url: string, fileName: string) => {
  let iframe = document.getElementById('download') as HTMLIFrameElement | null
  if (iframe) {
    iframe.remove()
    iframe = null
  }
  iframe = document.createElement('iframe')
  iframe.src = `https://downloads.99box.com/index.html?url=${url}&fileName=${fileName}`
  iframe.id = 'download'
  iframe.style.display = 'none'
  document.body.appendChild(iframe)
  iframe = null
}

/*下载客户端*/
export const DownloadClient = (replaceFileName?: (fileName: string) => string) => {
  const PreProcessInfo = GetPreProcessHS.SuccessResult
  if (PreProcessInfo) {
    /** 这里假如当前在商品详情页
     * 则详情页的地址为 /store/game/${gameLibraryId}/${gameId}
     * 通过split分割后， 第4个为gameId
     */
    const refererGame = window.location.pathname.startsWith('/store/game/')
      ? window.location.pathname.split('/')[4] || ''
      : ''
    SemDownloadHS.Execute({ id: `${PreProcessInfo.id}`, refererGame })
      .then(res => {
        if (res) {
          const url = new URL(res)
          if (replaceFileName) {
            CreateDownloadIframe(url.pathname, replaceFileName(PreProcessInfo.loadFileName))
          } else {
            CreateDownloadIframe(url.pathname, PreProcessInfo.loadFileName)
          }
        } else {
          window.open(downUrl())
        }
      })
      .catch(() => {
        window.open(downUrl())
      })
  }
}

/*工具类型*/
export const GameToolType = {
  1: '存档',
  2: 'MOD',
  3: '辅助',
}

/*获取文件哈希*/
export const SHA1File = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const fr = new FileReader()
    fr.onload = async ev => {
      const buffer: ArrayBuffer = ev.target?.result as ArrayBuffer
      resolve(
        hexString(await window.crypto.subtle.digest('SHA-1', buffer)) + file.name.substr(file.name.lastIndexOf('.')),
      )
    }
    fr.readAsArrayBuffer(file)
  })
}

/*获取字符串哈希*/
export const hexString = (buffer: ArrayBuffer) => {
  const byteArray = new Uint8Array(buffer)
  const hexCodes = [...byteArray].map(value => {
    const hexCode = value.toString(16)
    return hexCode.padStart(2, '0')
  })
  return hexCodes.join('')
}
export const CustomerIsOnline = (): boolean => {
  //2020-8-13 改为24小时在线
  return true

  // const Now = moment()
  // const TodayMM = Now.hour() * 60 + Now.minute() //今天过了多少分钟

  /*if ([1, 4].includes(Now.day())) {
    /!*周1/4： 9.30~00.00*!/
    return TodayMM > 9.5 * 60 && TodayMM < 24 * 60
  }
  if ([2, 3].includes(Now.day())) {
    /!*周2/3： 13.00~21.00*!/
    return TodayMM >= 13 * 60 && TodayMM <= 21 * 60
  }*/
  /*if ([2, 3].includes(Now.day())) {
    /!*周2/3： 13.00~21.00*!/
    return TodayMM >= 13 * 60 && TodayMM <= 21 * 60
  }*/
  /*if ([4, 5, 6].includes(Now.day())) {
    /!*周4/5/6 9:30 ~ 00:00*!/
    return TodayMM >= 9.5 * 60 && TodayMM <= 24 * 60
  }*/
  /*其它时间段 全天24小时*/
  // return TodayMM >= 10 * 60 && TodayMM <= 24 * 60
}

/*生成指定返回内的随机数*/
export const Random = (min: number, max: number) => {
  return Math.round(Math.random() * (max - min)) + min
}

/**
 * 比较两个版本大小
 * @param current 当前版本
 * @param ver 指定版本
 * @return boolean
 */
export const CompareVersion = (current: number[], ver: number[]) => {
  let VersionIsNew = false
  for (let i = 0; i < current.length; i += 1) {
    //当前版本大于指定版本
    if (current[i] > ver[i]) {
      VersionIsNew = true
      break
    } else if (current[i] < ver[i]) {
      VersionIsNew = false
      break
    }
  }
  return VersionIsNew
}
/**订单状态*/
export const OrderType: { [key in OrderType]: string } = {
  1: '独享',
  2: '直冲',
  3: '试玩账号',
  4: '试玩',
  6: '共享',
  7: '单机',
  8: '独享',
  9: '加速器',
  10: '升级独享',
  11: '集合包',
  12: 'CDK',
  13: '加速器卡密',
  19: '换购卡',
  21: '会员',
  26: '换购',
  17: '礼包抽奖',
  18: 'VIP客服服务',
  23: '升级CDK',
  22: '代购',
  27: '开箱次数',
  31: '福袋集合包',
  32: '道具',
  34: '存档购买',
  37: '会员升级',
  38: '代充',
  39: '捆绑包',
  41: '加速器时长',
  42: '云游戏时长',
  43: '合约',
  44: '游戏本体',
}
/**账号类型*/
export const AccountType: { [key: number]: string } = {
  6: '卡密',
  8: '直冲',
  9: 'CDK',
  37: '加速器',
}

/**
 * 两个float数相乘小数进度精度错误
 * @param arg1
 * @param arg2
 */
export const floatMul = (arg1: number, arg2: number) => {
  let m = 0
  const s1 = arg1.toString()
  const s2 = arg2.toString()
  try {
    m += s1.split('.')[1].length
  } catch (e) {
    console.error(e)
  }
  try {
    m += s2.split('.')[1].length
  } catch (e) {
    console.error(e)
  }
  return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / 10 ** m
}

export const isTimes = (curdate: number, startTime: string, endTime: string) => {
  const startdate = new Date(startTime)
  const enddate = new Date(endTime)
  const a = curdate - startdate.getTime() / 1000
  const b = curdate - enddate.getTime() / 1000

  if (a < 0 || b > 0) {
    return false
  } else {
    return true
  }
}

export const signatureEncode = (str: string) => {
  //算法: 先反序、再sha256、再反序、再md5
  const timeR = String(str).split('').reverse().join('')
  const timeSha256R = sha256(timeR).split('').reverse().join('')
  return md5(timeSha256R)
}

/** 判断富文本内容是否为空 */
export const htmlIsEmpty = (html: string) => {
  const finalHTML = html.replace(/<p>/g, '').replace(/<\/p>/g, '')
  return !finalHTML.trim()
}

/**
 * 最多保留N位小数
 * @param num
 * @param fractionDigits
 */
export const toFixed = (num: string | number, fractionDigits: number) => {
  const _num = String(num)
  if (!_num.includes('.') || isNaN(Number(num))) {
    return num
  }
  const arr = _num.split('.')
  arr[1] = arr[1].substr(0, fractionDigits)
  return arr.join('.')
}
/**
根据身份证号码判断性别
15位身份证号码：第7、8位为出生年份(两位数)，第9、10位为出生月份，第11、12位代表出生日
18位身份证号码：第7、8、9、10位为出生年份(四位数)，第11、第12位为出生月份，
第13、14位代表出生日期，第17位代表性别，奇数为男，偶数为女。
*/
//根据身份证号获取年龄
export const getAge = (identityCard: string): number => {
  const len = (identityCard + '').length
  let strBirthday = ''
  if (len === 18) {
    //处理18位的身份证号码从号码中得到生日和性别代码
    strBirthday = identityCard.substr(6, 4) + '/' + identityCard.substr(10, 2) + '/' + identityCard.substr(12, 2)
  }
  if (len === 15) {
    let birthdayValue = ''
    birthdayValue = identityCard.charAt(6) + identityCard.charAt(7)
    if (parseInt(birthdayValue) < 10) {
      strBirthday =
        '20' + identityCard.substr(6, 2) + '/' + identityCard.substr(8, 2) + '/' + identityCard.substr(10, 2)
    } else {
      strBirthday =
        '19' + identityCard.substr(6, 2) + '/' + identityCard.substr(8, 2) + '/' + identityCard.substr(10, 2)
    }
  }
  //时间字符串里，必须是“/”
  const birthDate = new Date(strBirthday)
  const nowDateTime = new Date()
  let age = nowDateTime.getFullYear() - birthDate.getFullYear()
  //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
  if (
    nowDateTime.getMonth() < birthDate.getMonth() ||
    (nowDateTime.getMonth() === birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())
  ) {
    age--
  }
  return age
}

/** 小于1M, 转换成K, 大于1M，转成M  */
export const exchangeSize = (size: number) => {
  if (size === 0) {
    return `0B`
  } else if (size < 1024 * 1024) {
    return `${(size / 1024).toFixed(2)}KB`
  } else {
    return `${(size / 1024 / 1024).toFixed(2)}MB`
  }
}

// 获取视频的封面
export const getVideoPoster = (width: number, height: number, videoUrl: string) => {
  return videoUrl + `?x-oss-process=video/snapshot,t_2000,f_jpg,w_${width},h_${height}`
}

/**
 *
 * @param arr  一维数组
 * @param n  设置几个为一行
 */
export const arrayToDim = (arr: Array<any>, n = 3) => {
  const newArray = []
  for (let i = 0; i < Math.ceil(arr.length / n); i++) {
    newArray[i] = arr.slice(i * n, (i + 1) * n)
  }
  return newArray
}

// 将时间转换成几天前，几个月前，几小时前等
export const getDateDiff = (dateTimeStamp: number) => {
  //dateTimeStamp是一个时间毫秒，注意时间戳是秒的形式，在这个毫秒的基础上除以1000，就是十位数的时间戳。13位数的都是时间毫秒。
  let result: string = ''
  const minute = 1000 * 60 //把分，时，天，周，半个月，一个月用毫秒表示
  const hour = minute * 60
  const day = hour * 24
  const week = day * 7
  const halfamonth = day * 15
  const month = day * 30
  const year = month * 12
  const now = new Date().getTime() //获取当前时间毫秒
  const diffValue = now - dateTimeStamp //时间差

  if (diffValue < 0) {
    return
  }
  const minC = diffValue / minute ////计算时间差的分，时，天，周，月
  const hourC = diffValue / hour
  const dayC = diffValue / day
  const yearC = diffValue / year
  const weekC = diffValue / week
  const monthC = diffValue / month
  if (yearC >= 1) {
    result = moment(dateTimeStamp).format('YY-MM-DD HH:mm:ss')
  } else if (dayC >= 1 && yearC <= 1) {
    result = moment(dateTimeStamp).format('MM-DD HH:mm:ss')
  } else if (hourC > 3 && hourC <= 24) {
    result = moment(dateTimeStamp).format('MM-DD HH:mm:ss')
  } else if (hourC >= 1 && hourC <= 3) {
    result = ' ' + Math.floor(hourC) + '小时前'
  } else if (minC > 30 && minC <= 59) {
    result = '1小时内'
  } else if (minC > 10 && minC <= 30) {
    result = '半小时内'
  } else if (minC >= 1 && minC <= 10) {
    result = '10分钟内'
  } else if (diffValue >= 0 && diffValue <= minute) {
    // && diffValue <= minute
    result = '刚刚'
  }
  return result
}
//列表格式化富文本显示
export const fiflterListRichText = (str: string) => {
  str = fiflterRichText(str)
  str = str.replace(/<.*?>/g, '')
  str = str.replace(/<\s?img[^>]*>/g, '')
  str = str.replace(/<\s?video[^>]*>/g, '')
  str = str.replace(/\n/g, '')
  str = str.replace(/\s/g, '')
  return str
}

//格式化富文本显示 换行问题
export const fiflterRichText = (str: string) => {
  str = str.replace(/<p><\/p><div class="media-wrap image-wrap"><\/div>/g, '')
  str = str.replace(/<p><\/p><div class="media-wrap video-wrap"><\/div>/g, '')
  str = str.replace(/(^(<br>)+)|((<br>)+$)/g, '')
  return str
}
//检测字符串中文
export function checkChinese(htmlStr: string) {
  const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
  return reg.test(htmlStr)
}

//格式化文本域显示,防止xss
export const fiflterTextAreaXss = (str: string) => {
  str = str.replace(/[<]|[>]/g, '')
  str = str.replace(/\n/g, '<br>')
  str = str.replace(/\s/g, '&nbsp;')
  return str
}

//提取html字符串中的文本
export const getSimpleText = (html: string) => {
  const re1 = new RegExp('<.+?>', 'g') //匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
  const msg = html.replace(re1, '') //执行替换成空字符
  return msg
}
export const clearSelections = () => {
  // 获取选中
  const selection = window.getSelection()
  // 清除选中
  selection?.removeAllRanges()
}

/** 获取剪切板内容 */
export const getClipboard = (timeout: number = 1000) => {
  return new Promise((resolve, reject) => {
    if (window.FuluApp) {
      const timer = setTimeout(() => {
        resolve(null)
      }, timeout)
      window.FuluApp.clipboardResolve = (content: string) => {
        if (timer) {
          clearTimeout(timer)
        }
        resolve(content)
      }
      window.FuluApp.JSNotifyCppFunc('get_clipboard')
    } else {
      reject('must be in the client')
    }
  })
}
